module.exports = __webpack_public_path__ + "img/nao_mexer_mascara2.56dd20f5.svg";